import React, { memo } from "react";
import { icon } from "../utils/icons";

const SearchFilter = ({ value, changeHandler, ...rest }) => {
    return (
        <div className="serach relative">
            <span className="absolute text-xl z-10 top-0 h-full w-[40px] flex items-center justify-center start-0">
                {icon.search}
            </span>
            <input
                {...rest}
                value={value}
                onChange={e => changeHandler(e.target.value)}
                type="text"
                name="search"
                className="p-2  ps-[40px] relative w-full  border rounded-lg transition-all  focus:border-third-color shadow-sm outline-none border-light-color"
            />
        </div>
    );
};

export default memo(SearchFilter);
